import { RecordType } from '@xbcb/shared-types';
import { documentFields } from './document';

export const recordTypeToRecordFieldsMap = {
  [RecordType.DOCUMENT]: documentFields,
};
